// Version tracking for deployment verification
// Increment version when making changes to verify deployment
export const APP_VERSION = '1.8.2';
export const BUILD_DATE = '2025-12-04';

// Page-specific versions (increment when that page changes)
export const PAGE_VERSIONS = {
  gmPanel: '1.1.0',
  playerView: '1.2.0',
  demo: '1.4.0',
  landing: '1.0.3',
  visualEditor: '1.2.1',
  visualPlanner: '1.4.1',
  compiler: '1.8.0',
};
